export enum ReportKey {
  DatesAtAGlance = 'datesAtAGlance',
  NewClosedProjects = 'newClosedProjects',
  OverdueTasks = 'overdueTasks',
  ProjectDuration = 'projectDuration',
  StructuralPassFail = 'structuralPassFail',
}
